import React from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { EMPTY_OBJECT } from '../../constants/globalConstants'
import PaymentGatwayHeartLand from './PaymentGatewayHeartLand'
import PGIframeDC from './PGIframeDC'
const DefaultComponent = () => <></>
function PaymentGatewayCommon(props) {
    const {
        onSubmit, faciltyData, isSubmittingForm, page,
        setIsSubmittingForm, amount, consent, prevButton,
        setFormData, formData, loginUser, LoginSignUpButton,
        previousButton, confirmPay, isCheckOutStatus, paymentDisable,
        setValue, customGateWay, APILoad, isSubmitDisabled, onSubmitBlocked
    } = props
    const mainForm = () => {
        return <section>
            {faciltyData?.facility_configuration?.is_iframe_enabled == '0' ? customGateWay :
            faciltyData?.facility_payment_details?.facility_payment_type_id == '4' ? <PaymentGatwayHeartLand
                paymentData={faciltyData}
                onSubmit={onSubmit}
                isSubmittingForm={isSubmittingForm}
                amount={amount}
                consent={consent}
                prevButton={prevButton}
                setFormData={setFormData}
                formData={formData}
                loginUser={loginUser}
                LoginSignUpButton={LoginSignUpButton}
                previousButton={previousButton}
                confirmPay={confirmPay}
                isCheckOutStatus={isCheckOutStatus}
                paymentDisable={paymentDisable}
                page={page}
                setValue={setValue}
                isSubmitDisabled={isSubmitDisabled}
                onSubmitBlocked={onSubmitBlocked}
            /> :
            faciltyData?.facility_payment_details?.facility_payment_type_id == '2' ? 
            <PGIframeDC consent={consent} setIsSubmittingForm={setIsSubmittingForm} isSubmittingForm={isSubmittingForm} onSubmit={onSubmit} setValue={setValue} faciltyData={faciltyData} page={page} previousButton={previousButton} setFormData={setFormData} formData={formData} APILoad={APILoad} isSubmitDisabled={isSubmitDisabled} onSubmitBlocked={onSubmitBlocked} /> :
                null
            }
        </section>
    }
    return (
        <div>{mainForm()} </div>
    )
}

PaymentGatewayCommon.propTypes = {
    faciltyData: PropTypes.object,
    isSubmittingForm: PropTypes.bool,
    setIsSubmittingForm: PropTypes.func,
    onSubmit: PropTypes.func,
    amount: PropTypes.string,
    consent: PropTypes.elementType,
    prevButton: PropTypes.elementType,
    setValue: PropTypes.func,
    formData: PropTypes.object,
    setFormData: PropTypes.func,
    loginUser: PropTypes.bool,
    isCheckOutStatus: PropTypes.bool,
    paymentDisable: PropTypes.bool,
    LoginSignUpButton: PropTypes.elementType,
    previousButton: PropTypes.elementType,
    confirmPay: PropTypes.elementType,
    customGateWay: PropTypes.elementType,
    page: PropTypes.string,
    isSubmitDisabled: PropTypes.bool,
    onSubmitBlocked: PropTypes.func,
    APILoad: PropTypes.oneOfType([
        PropTypes.func, 
        PropTypes.shape({ current: PropTypes.any })
    ])
}

PaymentGatewayCommon.defaulProps = {
    faciltyData: EMPTY_OBJECT,
    isSubmittingForm: false,
    setIsSubmittingForm: noop,
    onSubmit: noop,
    amount: '',
    consent: DefaultComponent,
    prevButton: DefaultComponent,
    setValue: noop,
    formData: EMPTY_OBJECT,
    setFormData: noop,
    loginUser: false,
    isCheckOutStatus: false,
    paymentDisable: false,
    LoginSignUpButton: DefaultComponent,
    previousButton: DefaultComponent,
    confirmPay: DefaultComponent,
    customGateWay: DefaultComponent,
    page: '',
    isSubmitDisabled: false,
    onSubmitBlocked: noop,
    APILoad: null
}
export default PaymentGatewayCommon
